import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { KibbleThemeProvider } from '@televet/kibble-ui';
import type { AuthContext } from '@/providers/auth';
import { AstroPetInternalTRPCProvider } from '@/providers/trpc';

interface RouterContext {
  auth: AuthContext;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <AstroPetInternalTRPCProvider>
      <KibbleThemeProvider>
        <Outlet />
      </KibbleThemeProvider>
    </AstroPetInternalTRPCProvider>
  );
}
